import './Root.scss'
import { useGetSearchParam } from '../../hooks'
import { Navigate, Outlet } from 'react-router'
import { toast } from 'sonner'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router'
import { Toaster } from '@/components/shadcn/sonner'
import { TooltipProvider } from '@/components/shadcn/tooltip'

export function Root() {
  const authStatus = useGetSearchParam('authStatus')
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    if (!authStatus) return

    const clearAuthStatus = () => {
      const updatedSearchParams = new URLSearchParams(searchParams)
      updatedSearchParams.delete('authStatus')
      setSearchParams(updatedSearchParams)
    }

    switch (authStatus) {
      case 'login-success':
        toast.success('Logged in successfully', {
          id: authStatus,
          duration: 1000,
        })
        break
      case 'logout-success':
      case 'logout-failed': // sometimes the call to backend to logout fails but we still cleared the session
        toast.info('Logged out successfully', {
          id: authStatus,
          duration: 1000,
        })
        break
      case 'login-failed':
        toast.error('There was an issue logging you on.  Please contact your administrator.', {
          id: authStatus,
          duration: 3000,
        })
        break
    }
    clearAuthStatus()
  }, [authStatus, searchParams, setSearchParams])

  if (authStatus === 'login-failed') {
    return <Navigate to="/" replace />
  }

  return (
    <div className="ux-root">
      <TooltipProvider>
        <Outlet />
        <Toaster position="bottom-center" />
      </TooltipProvider>
    </div>
  )
}
